export default __webpack_public_path__ + "static/media/circularBg.5c4297fe.png";